import type { FlexProps } from '@chakra-ui/react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { ColorThemeVars } from '@veno-app/chakra';
import { NftSlot } from '@veno-app/icons';
import type { SVGProps } from 'react';
import React from 'react';

type EmployHelperCardProps = {
  title: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  disabled?: boolean;
} & FlexProps;

function EmployHelperCard({
  title,
  icon,
  disabled,
  onClick,
  ...flexProps
}: EmployHelperCardProps) {
  return (
    <Flex
      gap={1}
      flexDir="column"
      cursor={disabled ? 'auto' : 'pointer'}
      bg={`var(${ColorThemeVars.mainColorLight})`}
      rounded="5px"
      borderColor="brand-primary"
      borderWidth="1px"
      borderStyle="dashed"
      w="106px"
      h="106px"
      justify="center"
      position="relative"
      align="center"
      shadow={disabled ? undefined : `var(${ColorThemeVars.parentShadow})`}
      opacity={disabled ? 0.5 : undefined}
      onClick={disabled ? undefined : onClick}
      _dark={{
        borderColor: 'brand-blue',
      }}
      {...flexProps}
    >
      <Icon
        as={NftSlot}
        w="54px"
        h="54px"
        color="brand-primary"
        _dark={{
          color: 'brand-blue',
        }}
      />
      <Text textStyle="textLink" color={`var(${ColorThemeVars.accent})`}>
        {title}
      </Text>
      <Icon
        as={icon}
        color={`var(${ColorThemeVars.accent})`}
        w={6}
        h={6}
        position="absolute"
        top="20px"
      />
    </Flex>
  );
}

export default EmployHelperCard;
